<template>
  <!-- 당근 다이얼로그: 좌측 세로 탭(출석보상/버츄패스/구매하기) + 우측 컨텐츠 (GatherPage 패널 공용) -->
  <v-dialog
    :value="value"
    width="760"
    scrollable
    overlay-color="#000"
    :overlay-opacity="$vuetify.theme.dark ? 0.6 : 0.75"
    @input="$emit('input', $event)"
    content-class="cur-dialog-shell"
  >
    <v-card class="cur-dialog">
      <div class="cur-dialog__head">
        <span class="cur-dialog__title">당근</span>
        <v-chip color="#fff3e0" text-color="#e8743b" class="font-weight-bold ml-3">
          🥕 {{ currencyBalance.toLocaleString() }}
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </div>

      <div class="cur-dialog__body">
        <v-tabs v-model="tab" vertical color="#c98a2e" slider-color="#c98a2e" class="cur-tabs">
          <v-tab class="justify-start">📅 출석보상</v-tab>
          <v-tab class="justify-start">🎟️ 버츄패스</v-tab>
          <v-tab class="justify-start">🛒 구매하기</v-tab>
        </v-tabs>

        <div class="cur-content">
          <v-tabs-items v-if="value" v-model="tab">
            <v-tab-item><AttendancePanel /></v-tab-item>
            <v-tab-item><VirtupassPanel /></v-tab-item>
            <v-tab-item><CarrotShopPanel /></v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import AttendancePanel from "./AttendancePanel.vue";
import VirtupassPanel from "./VirtupassPanel.vue";
import CarrotShopPanel from "./CarrotShopPanel.vue";

export default {
  name: "CurrencyDialog",
  components: { AttendancePanel, VirtupassPanel, CarrotShopPanel },
  props: {
    value: { type: Boolean, default: false },
  },
  data: () => ({ tab: 0 }),
  computed: {
    ...mapState(["currencyBalance"]),
  },
  watch: {
    value(open) {
      if (open) this.$store.dispatch("loadCurrencyBalance");
    },
  },
};
</script>

<style scoped>
.cur-dialog {
  border-radius: 18px;
  overflow: hidden; /* 좌측 탭 배경이 둥근 모서리를 덮지 않도록 클리핑 */
}
.cur-dialog__head {
  display: flex;
  align-items: center;
  padding: 16px 18px;
  border-bottom: 1px solid #eee8f8;
}
.cur-dialog__title {
  font-family: maplestory;
  font-size: 20px;
  font-weight: 700;
  color: #2b2440;
}
.cur-dialog__body {
  display: flex;
  align-items: stretch;
  min-height: 540px;
}
.cur-tabs {
  flex: 0 0 150px;
  border-right: 1px solid #f0ecf7;
  background: #faf8fd;
}
.cur-tabs >>> .v-tab {
  justify-content: flex-start;
  font-weight: 700;
  letter-spacing: -0.01em;
  text-transform: none;
}
.cur-content {
  flex: 1 1 auto;
  min-width: 0;
  padding: 20px 22px;
  overflow-y: auto;
}
</style>
